import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  isCorporateVerified,
  VERIFY_CORPORATE_EMAIL_NAV_STATE,
} from "../Utils/corporateVerification.js";

/**
 * Redirects to Profile when the account is not corporate-verified.
 * Shows a brief loading state until profile data from Redux is available.
 */
export default function RequireCorporateVerified({ children }) {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.userReducer);

  const profileLoaded = Boolean(
    userDetails && (userDetails.email || userDetails.id || userDetails.userId)
  );

  const verified = isCorporateVerified(userDetails);

  useEffect(() => {
    if (!profileLoaded) return;
    if (!verified) {
      navigate("/profile", {
        state: VERIFY_CORPORATE_EMAIL_NAV_STATE,
        replace: true,
      });
    }
  }, [profileLoaded, verified, navigate]);

  if (!profileLoaded) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "#021138" }}>
        Loading…
      </div>
    );
  }

  if (!verified) {
    return null;
  }

  return children;
}
